import VueCookie from 'vue-cookies';

VueCookie.getAllCookies = function () {
    return document.cookie
        .split('; ')
        .map((item) => item.split('='))
        .reduce((c, n) => {
            const key = n[0];
            const value = n[1];

            if (key) {
                c[key] = value;
            }

            return c;
        }, {});
};

VueCookie.hasCookies = function () {
    return !!Object.keys(this.getAllCookies()).length;
};

export const vueCookie = VueCookie;

export default VueCookie;
